/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 16:06:06
 * @LastEditors: xgx
 * @LastEditTime: 2023-03-23 11:08:36
 */
import req from "@/utils/request";
// 业务开始的数据对接
export const saveCollect = (params) => req.post("/interact-service/m/isQuestionnaireSurvey/saveQuestionnaire", params);
export const collectDetils = (params) => req.post("/interact-service/m/isQuestionnaireSurvey/id", params);
export const updateCollect = (params) => req.post("/interact-service/m/isQuestionnaireSurvey/updateQuestionnaire", params);
export const addOrUpdateQuestionnaireContent = (params) => req.post("/interact-service/m/isQuestionnaireContent/addOrUpdateQuestionnaireContent", params);
export const findListPage = (params) => req.post("/interact-service/m/isQuestionnaireSurvey/findListPage", params);
export const selectListByModelId = (params) => req.post("/interact-service/m/isQuestionnaireContent/findList", params);
export const findListProportion = (params) => req.post("/interact-service/m/isQuestionnaireContent/findListProportion", params);
export const collectDelete = (params) => req.post("/interact-service/m/isQuestionnaireSurvey/delete", params);
export const findLogList = (params) => req.post("/interact-service/m/IsQuestionnaireSurveyOperateLog/findLogList", params);
export const updateDisplayStatus = (params) => req.post("/interact-service/m/isQuestionnaireSurvey/updateDisplayStatus", params);